export const formatBytes = (bytes?: number | null): string => {
	if (bytes == null) {
		return "-";
	}

	const units = ["B", "KB", "MB", "GB"];
	let value = bytes;
	let unitIndex = 0;
	while (value >= 1024 && unitIndex < units.length - 1) {
		value /= 1024;
		unitIndex += 1;
	}

	return `${value.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
};

export const formatDate = (value?: string | Date | null, locale = "ja"): string => {
	if (!value || Number.isNaN(new Date(value).getTime())) {
		return "-";
	}

	return new Intl.DateTimeFormat(locale === "ja" ? "ja-JP" : "en-US", {
		year: "numeric",
		month: "short",
		day: "numeric",
	}).format(new Date(value));
};

export const formatDateTime = (value?: string | Date | null, locale = "ja"): string => {
	if (!value || Number.isNaN(new Date(value).getTime())) {
		return "-";
	}

	return new Intl.DateTimeFormat(locale === "ja" ? "ja-JP" : "en-US", {
		year: "numeric",
		month: "short",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	}).format(new Date(value));
};
